import type { CheckoutItemSource } from '../model/checkout_source.js';

/** Os itens do carrinho de UM produto, já estreitados para ele. */
export function itemsOf<I extends CheckoutItemSource, P extends I['productType']>(
  items: readonly I[],
  productType: P,
): Extract<I, { productType: P }>[] {
  return items.filter(
    (item): item is Extract<I, { productType: P }> => item.productType === productType,
  );
}
